import React, { Fragment, useContext, useEffect, useState } from 'react'
import SuggestedTags from 'shared/components/suggested-tags'
import UserContext from 'shared/contexts/user'
import styled from 'styled-components'
import { CreationToolsContext } from '../../../manager'
import CreationTool from '../../../types/creation-tool'
import CreationToolUploadField from '../../../types/upload-field'
import { UploadFieldBlock } from '../../blocks'
import { CreationToolUploadContext } from '../manager'

const Container = styled(UploadFieldBlock as any)`
    grid-column: span 4;

    > div {
        margin-bottom: 0;
    }
`

type Props = {
    className?: string
    field: CreationToolUploadField
    sourceId?: string
}

const CreationUploadSuggestedTagsField = ({ className, sourceId }: Props) => {
    const { user } = useContext(UserContext)
    const { tool } = useContext(CreationToolsContext)
    const { addTags, uploadSources, tags: globalTags, setSuggestedTagEventBuffer } = useContext(
        CreationToolUploadContext
    )
    const [lastEnteredTags, setLastEnteredTags] = useState<string[]>([])
    const uploadSource = sourceId ? uploadSources.find(({ id }) => id === sourceId) : uploadSources[0]
    const tags = sourceId ? uploadSource?.tags || [] : globalTags
    const endpoint = CreationTool.suggestedTagsEndpoint(tool)

    const onAddSuggestedTag = (tag: string, originator: string) => {
        addTags([{ text: tag, originator }], sourceId)
    }

    useEffect(() => {
        // update last entered tags to all tags with no originator value
        setLastEnteredTags(tags.filter(t => !t.originator).map(t => t.text))
    }, [tags])

    if (uploadSources.length > 1 && !sourceId) {
        // For multi-gif uploads, we want the suggested tags component to not pop up on
        // the right section so we return an empty fragment
        return <Fragment />
    }

    return (
        <Container className={className}>
            <SuggestedTags
                {...{
                    currentTags: tags.map(t => t.text),
                    lastEnteredTags,
                    endpoint,
                    addSugTag: onAddSuggestedTag,
                    isVertical: false,
                    userName: user.username,
                    source: uploadSource?.source,
                    onBufferedEventsChange: setSuggestedTagEventBuffer,
                }}
            />
        </Container>
    )
}

export default CreationUploadSuggestedTagsField
